import { useState, VFC } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'
import { createCompanySearchConditions } from 'src/api/needs'
import { asModal } from 'src/components/hoc/asModal'
import { toNeedsQueryParam } from 'src/models/Needs'
import { Persona } from 'src/models/Persona'
import {
  truewhite,
  _formalert,
  _profilegreen,
  _profileoverlay,
} from 'src/styles/colors'
import styled, { css } from 'styled-components'
import { PersonasContent } from './PersonasContent'
import { SmallButton } from 'src/elements/Button'

type ValuesType = {
  title: string
}

export type FilterSettingModalViewProps = {
  personaData: Persona
  close: VoidFunction
  getCompanySearchConditions: () => void
}

const FilterSettingModalView: VFC<FilterSettingModalViewProps> = ({
  personaData,
  close,
  getCompanySearchConditions,
}) => {
  const { register, handleSubmit, formState } = useForm<any>({
    defaultValues: {
      title: '',
    },
  })
  const [errorMessages, setErrorMessages] = useState<string[]>([])
  const [title, setTitle] = useState<string | undefined>(undefined)

  const handleOnSubmit: SubmitHandler<ValuesType> = async (values) => {
    const res = await createCompanySearchConditions(
      values.title,
      JSON.stringify(toNeedsQueryParam(personaData)),
    )

    if (res.error?.errorMessages) {
      setErrorMessages(res.error.errorMessages)
      setTitle(undefined)
      return
    }
    await getCompanySearchConditions()
    setErrorMessages([])
    setTitle(undefined)
    close()
  }

  return (
    <StyledForm onSubmit={handleSubmit(handleOnSubmit)}>
      <Layout>
        <FilterSettingModalHeader>
          検索条件を保存しますか？
          <p className="text">
            保存した条件は検索画面の上部メニュー「保存した検索条件」から使用することができます。
          </p>
        </FilterSettingModalHeader>
        <FilterTitleHeader>
          タイトル
          <span className="badge-required">必須</span>
        </FilterTitleHeader>
        <FilterTitleInputArea>
          <FilterTitleInput
            {...register('title', {
              value: title,
              required: '検索条件名は必須です',
            })}
          />
          <Alert>
            {!!formState.errors.title && (
              <p>{formState.errors.title.message}</p>
            )}
          </Alert>
        </FilterTitleInputArea>
        <FilterParamHeader>選択中の項目</FilterParamHeader>
        <FilterParamTable>
          <PersonasContentDiv>
            <PersonasContent personaData={personaData} />
          </PersonasContentDiv>
          <FilterParamButton>
            <CancelButton type="button" onClick={close}>
              キャンセル
            </CancelButton>
            <FilterSettingButton type="submit">保存する</FilterSettingButton>
          </FilterParamButton>
          <Alert>
            {errorMessages.length > 0 && (
              <p>
                {errorMessages.map((message) => (
                  <p key={message}>{message}</p>
                ))}
              </p>
            )}
          </Alert>
        </FilterParamTable>
      </Layout>
    </StyledForm>
  )
}

const modalOverlayStyle = css`
  backdrop-filter: blur(6px) brightness(0.5);
  background-color: ${_profileoverlay}80;
`

export const FilterSettingModal = asModal(FilterSettingModalView, {
  overlayStyle: modalOverlayStyle,
  scrollable: true,
})

const StyledForm = styled.form``

const Layout = styled.div`
  width: 530px;
  height: 600px;
  background: ${truewhite};
  border-radius: 10px;
  padding: 20px 40px;
`

const FilterSettingModalHeader = styled.div`
  font-size: 20px;
  font-weight: bold;

  .text {
    margin-top: 10px;
    font-size: 14px;
    font-weight: normal;
  }
`

const FilterTitleHeader = styled.div`
  font-size: 14px;
  color: #393e4c40;
  font-weight: bold;
  margin-top: 16px;
  margin-bottom: 10px;

  .badge-required {
    color: #fff;
    background: #ff6c00;
    font-size: 10px;
    padding: 5px 4px;
    border-radius: 5px;
    display: inline-block;
    font-weight: normal;
    margin-left: 5px;
  }
`

const FilterTitleInputArea = styled.div``

const FilterTitleInput = styled.input`
  display: block;
  width: 100%;
  height: 33px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.4;
  color: #6f6f6f;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 4px;
`

const FilterParamHeader = styled.div`
  font-size: 14px;
  color: #393e4c40;
  font-weight: bold;
  margin-top: 16px;
  margin-bottom: 10px;
`

const FilterParamTable = styled.div`
  display: flex;
  flex-direction: column;
`

const FilterParamButton = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
  margin-top: 40px;
`

const CancelButton = styled(SmallButton)`
  color: ${_profilegreen};
  background: ${truewhite};
  margin-right: 10px;
`

const FilterSettingButton = styled(SmallButton)`
  color: ${truewhite};
  background: ${_profilegreen};
`

const Alert = styled.div`
  color: ${_formalert};
  margin-bottom: 15px;
  p {
    text-align: center;
  }
`

const PersonasContentDiv = styled.div`
  width: 100%;
  border: 1px solid #393e4c40;
  padding: 10px;
  height: 280px;
  border-radius: 10px;
  overflow: scroll;
`
